export default __webpack_public_path__ + "static/media/supplierIcon.40a74585.svg";